import { render, staticRenderFns } from "./FollowUpPeriodModel.vue?vue&type=template&id=44b61a59&scoped=true"
import script from "./FollowUpPeriodModel.vue?vue&type=script&lang=js"
export * from "./FollowUpPeriodModel.vue?vue&type=script&lang=js"
import style0 from "./FollowUpPeriodModel.vue?vue&type=style&index=0&id=44b61a59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b61a59",
  null
  
)

export default component.exports